export default __webpack_public_path__ + "static/media/ASP.fd345168.png";